/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type VehicleFeaturesPropagationItemsAgreed = {
  itemCode: VehicleFeaturesPropagationItemsAgreed.itemCode;
  agreeYn: boolean;
  propagationSuccess: boolean;
  agreedDate: string;
};
export namespace VehicleFeaturesPropagationItemsAgreed {
  export enum itemCode {
    HMG_PRIVACY = 'HMG_PRIVACY',
    SAFETY_SCORE_3PARTY = 'SAFETY_SCORE_3PARTY',
    UBI_3PARTY = 'UBI_3PARTY',
    EV_BATTERY = 'EV_BATTERY',
    TIRE_PRESSURE = 'TIRE_PRESSURE',
  }
}

